<template>
  <div v-if="isReady" class="panel-body">
    <transition name="fade-expand" mode="out-in">
      <div v-if="!selectedSale" key="open">
        <p class="text-size-20">募集中のセール情報一覧</p>
        <transition-group name="expand-card" tag="div" class="sale-grid">
          <div
            class="sale-card"
            v-for="sale in displayData"
            :key="sale.saleId"
            @click="handleViewSaleEntry(sale)"
          >
            <sale-info :sale="sale" />
          </div>
        </transition-group>
      </div>
      <div v-else key="entry">
        <sale-entry :selectedSale="selectedSale" @backToTop="backToTop"/>
      </div>
    </transition>
  </div>
</template>

<script>
import SaleService from '@/services/salemasterservice'
import SaleInfo from './components/SaleInfo'
import SaleEntry from './SaleEntry'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    SaleInfo,
    SaleEntry
  },
  data () {
    return {
      isReady: false,
      loader: null,
      searchQuery: '',
      saleIds: [],
      salesData: [],
      displayData: []
    }
  },
  computed: {
    saleId () {
      return this.$route.params.saleId
    },
    selectedSale () {
      return this.salesData.find(i => i.saleId === this.saleId)
    }
  },
  created () {
    this.getSales()
    this.searchQuery = this.$route.query.search_query
    this.saleIds = this.$route.query.sale_ids ? this.$route.query.sale_ids.split(',').map(id => (id || '').toLowerCase()) : []
  },
  methods: {
    async getSales () {
      this.loader = this.$loading.show()
      await SaleService.getSaleOpen()
        .then((response) => {
          this.salesData = response.data
          if (this.searchQuery || this.saleIds.length > 0) {
            this.filterSales()
          } else {
            this.displayData = response.data
          }
          this.isReady = true
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    handleViewSaleEntry (sale = null) {
      const params = { saleId: sale.saleId }
      this.$router.replace({ params })
    },
    backToTop () {
      const query = {...this.$route.query}
      if (this.searchQuery) {
        query.search_query = this.searchQuery
      }

      if (this.saleIds.length > 0) {
        query.sale_ids = this.saleIds.join(',')
      }
      this.$router.replace({name: 'Sale', query: query})
    },
    filterSales () {
      const lower = str => str.toLowerCase()
      const matchIncludes = (target, keyword) => lower(target || '').includes(lower(keyword || ''))

      this.displayData = [...this.salesData].filter(i => {
        const matchSaleName = !this.searchQuery || matchIncludes(i.saleName, this.searchQuery)
        const matchSaleId = this.saleIds.length === 0 || this.saleIds.some(sid => matchIncludes(i.saleId, sid))

        return matchSaleName && matchSaleId
      })
    }
  },
  mounted () {
    const logParams = {
      name: eventCode.sale.open,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>
<style scoped>
.sale-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  align-items: stretch;
}
.sale-card {
  background: white;
  border: 1px solid #ccc;
  padding: 10px;
  position: relative;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  cursor: pointer;
}
.sale-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  background-color: #d1f3ff;
  border-color: #3eadfc;
  opacity: 0.8;
}
@media (max-width: 1024px) {
  .sale-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/sale/SaleOpen.vue